import {
  formatDeliveryOrderByCustomerDate,
  formatDeliveryOrderByCustomerQty,
  groupDeliveryOrdersByCustomer,
} from "@utils/report/delivery-order-by-customer";

function DeliveryOrderByCustomerTable({ data = [] }: { data?: any[] }) {
  const totals = data.reduce(
    (acc, entry) => {
      if (Array.isArray(entry.detail)) {
        entry.detail.forEach((dtl: any) => {
          acc.totalConvertedQty += Number(dtl.converted_qty || 0);
          acc.totalBaseQty += Number(dtl.base_qty || 0);
        });
      }
      return acc;
    },
    { totalConvertedQty: 0, totalBaseQty: 0 }
  );

  const groupedArray = groupDeliveryOrdersByCustomer(data);

  return (
    <div className="standard-table-wrapper">
      <table className="standard-table border-[1px] border-gray-200 rounded-xl">
        <thead>
          <tr>
            <th className="text-gray-400 text-sm">Product Code</th>
            <th className="text-gray-400 text-sm">Unit</th>
            <th className="text-gray-400 text-sm">Qty</th>
            <th className="text-gray-400 text-sm">Allocation Account</th>
            <th className="text-gray-400 text-sm">Delivery Date</th>
            <th className="text-gray-400 text-sm">Status</th>
            <th className="text-gray-400 text-sm">Sales Description</th>
          </tr>
        </thead>
        <tbody>
          {groupedArray.map(({ customerLabel, orders }) => (
            <>
              <tr key={`${customerLabel}-section`} className="bg-blue-200">
                <td colSpan={7} className="py-2 text-center text-[#002C76]">
                  Customer-BU : {customerLabel}
                </td>
              </tr>
              {orders.map((order, orderIndex: number) => (
                <>
                  <tr
                    key={`${customerLabel}-order-${order.goods_request_note_code}-${orderIndex}`}
                    className="bg-blue-100"
                  >
                    <td colSpan={7} className="py-2">
                      <div className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-2">
                          <span className="font-semibold">{orderIndex + 1}</span>
                          <span>Ref No : {order.goods_request_note_code}</span>
                        </div>
                        <span>Way : {order.way_name}</span>
                      </div>
                    </td>
                  </tr>
                  {order.detail?.map((dtl: any, detailIndex: number) => (
                    <tr
                      key={`${customerLabel}-detail-${orderIndex}-${detailIndex}`}
                    >
                      <td>{`${dtl.product_name}(${dtl.product_code})`}</td>
                      <td>{dtl.unit_name}</td>
                      <td>{formatDeliveryOrderByCustomerQty(dtl)}</td>
                      <td>{dtl.warehouse_name}</td>
                      <td>{formatDeliveryOrderByCustomerDate(order)}</td>
                      <td>{order.status}</td>
                      <td>{order.description}</td>
                    </tr>
                  ))}
                </>
              ))}
            </>
          ))}
        </tbody>
        <tfoot>
          <tr className="font-bold">
            <td colSpan={2}>Qty Totals :</td>
            <td>
              {totals.totalConvertedQty} | {totals.totalBaseQty}
            </td>
            <td colSpan={4}></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default DeliveryOrderByCustomerTable;
